import { UserInfo } from '@spotify-internal/oauth-silent-authentication';
import { IS_CLIENT_ENV } from '@helpers/constants';
import silentAuth from './silentAuth';
import { AccessToken } from './types';

const hasSupport =
  typeof window === 'object' &&
  window.location.protocol === 'https:' &&
  /\.spotify\.(net|com)$/.test(window.location.hostname);

export async function getSilentAuthToken(): Promise<AccessToken> {
  // logged out on server
  if (!IS_CLIENT_ENV) {
    return undefined;
  }

  // fail when not supported
  if (!hasSupport) {
    throw new Error('failed to get access token');
  }

  try {
    return await silentAuth.getToken();
  } catch (error) {
    if (error.error === 'login_required') {
      return undefined;
    }

    throw error;
  }
}

export async function login(
  redirectUri = `${window.location.origin}/${process.env.BASEPATH}/callback`,
) {
  return silentAuth.login(redirectUri);
}

export async function logout(
  redirectUri = `${window.location.origin}/${process.env.BASEPATH}`,
) {
  return silentAuth.logout(redirectUri);
}

export async function getUserInfo() {
  return silentAuth.getUserInfo() as UserInfo | undefined;
}
